import React from 'react';
import SmallBlocks from './SmallBlocks';
import CreditScore from './CreditScore';
import StrongestCompanyCard from '../../../../../components/reusable/StrongestCompanyCard';
import { Col, Row } from 'antd';
import Contact from './Contact';
import BuyReportLink from '../components/BuyReportLink';
import BasicInfo from './BasicInfo';
import FinancialInfo from './FinancialInfo';
import BuyReportWrapper from '../components/BuyReportWrapper';

const Summary = ({ report, handleBuyReport }) => {
  // Reorder the array to place "TrustedEmployer" at the end (needs to be on the right)

  const certificates = report?.strongest?.certificates || [];

  const reorderedCertificates = [
    ...certificates.filter(item => item.certificateType !== 'TrustedEmployer'),
    ...certificates.filter(item => item.certificateType === 'TrustedEmployer'),
  ];

  return (
    <>
      <Row gutter={16}>
        {reorderedCertificates.map((item, index) => (
          <Col
            className="flex"
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={24}
            xxl={reorderedCertificates.length > 1 ? 12 : 24}
            key={index}
          >
            <StrongestCompanyCard type={item.certificateType} year={item.yearOfCertificate} />
          </Col>
        ))}
      </Row>
      <BuyReportWrapper handleBuyReport={handleBuyReport}>
        <CreditScore />
        <SmallBlocks />
      </BuyReportWrapper>
      <Row gutter={[30]}>
        <BasicInfo />
        <FinancialInfo />
      </Row>
      <Row gutter={[30]}>
        <Contact />
        <BuyReportLink handleBuyReport={handleBuyReport} />
      </Row>
    </>
  );
};

export default Summary;
